import { Radio, cn } from '@heroui/react'

const CustomRadio = (props: React.ComponentProps<typeof Radio>) => {
	// Extract description so we can render and style it here
	const { children, description, ...otherProps } = props as React.ComponentProps<typeof Radio> & {
		description?: React.ReactNode
	}

	return (
		<Radio
			{...otherProps}
			classNames={{
				base: cn(
					'inline-flex m-0 bg-content1 hover:bg-content2 items-center justify-between',
					'flex-row-reverse w-full max-w-lg cursor-pointer rounded-xl gap-4 p-4 border-2 border-transparent',
					'data-[selected=true]:border-primary'
				),
			}}
		>
			<div className="flex-1">
				{children}
				{description && <div className="mt-1.5 text-sm text-neutral-500">{description}</div>}
			</div>
		</Radio>
	)
}

export default CustomRadio
